import { useEffect, useState } from "react";

/**
 * Current time, refreshed on an interval — for live countdowns and relative
 * timestamps. UI machinery hook (owns its own interval), so business
 * components stay free of `useState`/`useEffect`.
 */
export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, intervalMs);
    return () => {
      clearInterval(timer);
    };
  }, [intervalMs]);

  return now;
}
